module.exports = __webpack_public_path__ + "static/pic01-1c07e9771367b32cb97e9a7df1c16c02.jpg";